module.exports = __webpack_public_path__ + "static/media/logo.eb90f525.svg";